import { gql } from '@apollo/client';


export const GET_TRACK_EXPORT_TASK_LIST = gql`
  query GetTrackExportTaskList(
    $page: Int!
    $size: Int!
    $status: Int
    $operatorId: Long
  ) {
    getTrackExportTaskList(page: $page, size: $size, status: $status, operatorId: $operatorId) {
      content {
        id
        taskNo
        fileName
        operatorId
        operatorName
        status
        internalS3Key
        externalS3Key
        errorDetailJson
        createdAt
        updatedAt
      }
      page
      size
      totalElements
      totalPages
      hasNext
      hasPrevious
    }
  }
`;

export const GET_TRACK_EXPORT_TASK_DETAIL = gql`
  query GetTrackExportTaskDetail($id: Long!) {
    getTrackExportTaskDetail(id: $id) {
      id
      taskNo
      fileName
      operatorId
      operatorName
      status
      internalS3Key
      externalS3Key
      errorDetailJson
      createdAt
      updatedAt
    }
  }
`;

export const GET_TRACK_EXPORT_INTERNAL_DOWNLOAD_URL = gql`
  query GetTrackExportInternalDownloadUrl($taskId: Long!) {
    getTrackExportInternalDownloadUrl(taskId: $taskId)
  }
`;

export const GET_TRACK_EXPORT_EXTERNAL_DOWNLOAD_URL = gql`
  query GetTrackExportExternalDownloadUrl($taskId: Long!) {
    getTrackExportExternalDownloadUrl(taskId: $taskId)
  }
`;

export const GET_TRACK_EXPORT_UPLOAD_TEMPLATE_BASE64 = gql`
  query GetTrackExportUploadTemplateBase64 {
    getTrackExportUploadTemplateBase64
  }
`;
